import React, { Fragment, useEffect, useRef, useState } from 'react';

import Language from './Language';
import Searchbar from './Searchbar';
import Notificationbar from './Notificationbar';
import MoonLight from './MoonLight';
import CartHeader from './CartHeader';
import BookmarkHeader from './BookmarkHeader';
import UserHeader from './UserHeader';
import { UL } from '../../../AbstractElements';
import { Col } from 'reactstrap';
import FullScreenToggle from './FullScreenToggle';
import { formatExpiryTime, getExpiryRelativeTime } from '../../../utils/licenseDataAndExpiry';
import { useLicense } from '../../../_helper/license/LicenseContext';
import { usePharmacy } from '../../../_helper/PharmacyProvider';
import { getStaffShiftHistory } from '../../../Components/ManageStaff/service/manage-staff-service';
import { useCurrency } from '../../../_helper/CurrencyContext';
import { useTranslation } from 'react-i18next';
import { Info } from 'react-feather';

const RightHeader = () => {
  const { t } = useTranslation();
  const { licenseData } = useLicense();
  const { pharmacyPOS } = usePharmacy();
  const { currency, getCurrencySymbol, allowedCurrencies } = useCurrency();
  const [showAll, setShowAll] = useState(false);
  const dropdownRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [collectionAmount, setCollectionAmount] = useState({});

  useEffect(() => {
    getCollectionAmount()
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowAll(false);
      }
    };

    if (showAll) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAll]);

  const updateCollectionAmount = async () => {
    setLoading(true);
    await getCollectionAmount();
    setShowAll(!showAll);
    setLoading(false);
  };

  const getCollectionAmount = async () => {
    const body = {
      cashierId: pharmacyPOS._id,
      status: "running",
    };

    try {
      const response = await getStaffShiftHistory(body);

      if (response.data.status === "success") {
        const shift =
          response.data.data?.pharmacyUserList?.[0];

        setCollectionAmount(
          shift?.totalSalesSystemCalculatedAmount || {}
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const formatAmountByCurrency = () => {
    if (!collectionAmount || !currency) return "—";

    const amount = collectionAmount[currency] ?? 0;
    const symbol = getCurrencySymbol(currency);

    return `${symbol}${amount.toFixed(2)}`;
  };


  return (
    <Fragment>
      <Col xxl='7' xl='6' md='5' className='nav-right right-header p-0 ms-sm-auto col d-flex justify-content-end'>
        {/* <Col md="8"> */}
        <UL attrUL={{ className: 'simple-list nav-menus flex-row flex-nowrap' }}>
          {/* <Language /> */}
          {/* <Searchbar /> */}
          {/* <BookmarkHeader /> */}

          {/* <p className="mb-0">
            License expires at: <strong>{formatExpiryTime(licenseData?.expiresAt)}</strong>
          </p> */}
          {/* <LicenseExpiryInfo expiresAt={licenseData?.expiresAt} /> */}
          {/* <li className="onhover-dropdown">
            <div className="d-flex align-items-center gap-2 px-2">
              <div className="text-end">
                <small className="text-muted">{t("Today's Collection")}</small>
                <h6 className="mb-0 fw-semibold">
                  {formatAmountByCurrency()}
                </h6>
              </div>
            </div>
          </li> */}
          <div className="d-flex align-items-center gap-2 position-relative">
            <small className="fw-bold">{t("Today's Collection")}</small>
            {!loading && <Info
              size={18}
              style={{ cursor: 'pointer' }}
              onClick={() => updateCollectionAmount()}
            />}
            {loading && (
              <div className="spinner-border text-primary" style={{
                height: '15px',
                width: '15px',
              }} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
            {!loading && showAll && (
              <div
                ref={dropdownRef}
                className="position-absolute bg-dark shadow rounded p-3 mt-2"
                style={{
                  top: '100%',
                  right: 0,
                  zIndex: 1000,
                  minWidth: '220px',
                  border: '1px solid #ddd',
                }}
              >
                {Object.keys(collectionAmount || {}).length === 0 ? (
                  <div className="text-center fw-bold">
                    <span className='text-secondary'>
                      {getCurrencySymbol()}0.00
                    </span>
                  </div>
                ) : (
                  Object.keys(collectionAmount).map((currency) => (
                    <div
                      key={currency}
                      className="d-flex justify-content-between py-1"
                    >
                      <span>{currency}</span>
                      <strong>
                        {getCurrencySymbol(currency)}
                        {Number(collectionAmount[currency] || 0).toFixed(2)}
                      </strong>
                    </div>
                  ))
                )}

                <div
                  className="text-end mt-3 text-primary" style={{ cursor: 'pointer' }}
                  onClick={() => setShowAll(false)}
                >
                  Close
                </div>
              </div>
            )}
          </div>

          {/* Dropdown */}
          <MoonLight />
          <FullScreenToggle />
          {/* <CartHeader /> */}
          {/* <Notificationbar /> */}
          <UserHeader />
        </UL>
        {/* </Col> */}
      </Col>
    </Fragment>
  );
};

export default RightHeader;
